/**
 * <RealizationsSkeleton> — la forme des « Activités terminées » pendant leur premier chargement.
 *
 * L'en-tête reste ; la carte-liste attend, en lignes d'activité FAITE (`<ActivityRowSkeleton
 * done>`) : la date et la chip de statut à droite, comme les lignes qui vont arriver.
 */
import React from "react"

import { ActivityRowSkeleton } from "../../molecules/ActivityRow/ActivityRowSkeleton"
import { CardList } from "../../molecules/CardList"

export function RealizationsSkeleton() {
    return (
        <CardList>
            <ActivityRowSkeleton titleWidth={170} done />
            <ActivityRowSkeleton titleWidth={120} done />
            <ActivityRowSkeleton titleWidth={150} done />
            <ActivityRowSkeleton titleWidth={130} done />
            <ActivityRowSkeleton titleWidth={160} done />
        </CardList>
    )
}
